var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',{attrs:{"type":_vm.type,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }